// extracted by mini-css-extract-plugin
export default {"link":"styles_link__Spnh7","platformLink":"styles_platformLink__n05OF"};